import React from 'react';
import { NodeData } from '../../store/store';

// Type definitions
interface TableOutputContentProps {
  data?: NodeData;
  type?: string;
}

const tableOutputStyle: React.CSSProperties = {
  background: '#ffe6e6', // Light red background specific to Table Output
};

const TableOutputContent: React.FC<TableOutputContentProps> = ({ data, type }) => (
  <>
    {/* Remove the direct icon rendering */}
    {/* <SaveOutlined /> */}
    <span>{data?.label || 'Table Output'}</span>
  </>
);

TableOutputContent.displayName = 'TableOutputContent';

// Export only the content component
// NodeWrapper will apply withNodeHandles to this component
export default TableOutputContent;
